export default {
    props: {
        label: { type: String },
        path: { type: String },
        vid: { type: String },
        value: { type: [Object, Number, String, Array] },
        rules: { type: [String, Array], default: undefined },
        returnObject: { type: Boolean, default: true },
        disabled: { type: Boolean, default: false },
        errors: { type: Array, default: () => [] },
        noDataReload: { type: Boolean, default: false },
        withInputField: { type: Boolean, default: false },
        onlyInputField: { type: Boolean, default: false },
        isFormElement: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        responseData: { type: Function, default: (response) => response.data.data },
        loadGenericId: { type: Function },
        apiGetResponseItemText: { type: [String, Function] },
        itemText: { type: [String, Function], default: 'data.name' },
        itemValue: { type: String, default: 'id' },
        clearable: { type: Boolean, default: true },
        mandatoryFilters: undefined,
        restoreInitialValues: { type: Boolean, default: false },
        buttonComponent: { type: String, default: undefined },
        getReloadPath: { type: Function, default: undefined },
        customReloadPath: { type: Function },
        noSearchBySortParam: { type: Boolean, default: false },
        excludeIds: { type: Array, required: false },
        cacheItems: { type: Boolean, default: true },
        multiple: { type: Boolean, default: false},
        chips: { type: Boolean, default: false },
        deletableChips: { type: Boolean, default: false },
        withExportButton: { type: Boolean, default: false },
        exportValue: { type: String, default: 'id'},
        exportComponent: { type: String },
        ignoreReloadData: { type: Boolean, default: false},
        forceToReloadData: { type: Boolean, default: false},
        emptyDisplayString: { type: String },
        navigateWithNewTab: { type: Boolean, default: false },
        selectId: { type: Boolean },
    },
}
